// frontend/src/services/socket.js
import io from 'socket.io-client';

// Must be the server origin, NOT REACT_APP_API_URL -- that one ends in /api,
// which is not a valid socket.io endpoint. Falls back to wherever this page
// was actually loaded from (not a hardcoded domain), so the same build
// works unmodified on any domain Nginx serves it from.
const SOCKET_URL =
    process.env.REACT_APP_SOCKET_URL ||
    process.env.REACT_APP_WEBSOCKET_URL ||
    (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5050');

const socket = io(SOCKET_URL, {
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    transports: ['websocket', 'polling'],
});

socket.on('connect', () => console.log('[socket] connected', SOCKET_URL));
socket.on('disconnect', (reason) => console.log('[socket] disconnected:', reason));
socket.on('connect_error', (err) => console.warn('[socket] connect error:', err.message));

export default socket;
